<template>
  <section class="signup-wrapper">
    <div class="signup">
      <div class="header">
        <div class="logo">
          <img
            src="@/assets/images/logo-lg.svg"
            class="unselectable mx-auto"
            alt
            width="86px"
            height="16px" 
          />
        </div>
        <p class="header-title">Passport Account</p>
        <span class="subtitle">Thank you for registering!</span>
      </div>
      <div class="content">
        <img
            src="@/assets/images/08-Email.svg"
            class="unselectable mx-auto mb-32"
            alt
            width="46px"
            height="33px" 
          />
        <p class="content-title">Please check your email.</p>
        <p class="content-info">
          We have sent you an email with a temporary password. Use it to login and set your own.
        </p>
        <div class="login-wrapper">
          <router-link class="login-btn"  variant="primary"
            :to="{ path: '/login', query: { email: this.user.email? this.user.email:this.user.form.user.email } }"
            >{{ $t('common.login')}}</router-link
          >
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import { mapState } from "vuex";
export default {
  computed: {
    ...mapState("authfack", ["user"]),
  },
};
</script>

<style lang="scss" scoped>
@media (max-width: 992px){
  .logo{
    width:116px!important;
    height: 22px!important;
   img{
  width:116px!important;
  height: 22px!important;
}
}
}
.signup-wrapper {
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  .signup {
    width: 500px;
    border-radius: 26px;
    background-color: #fff;
    padding: 50px 40px;
    .header {
      text-align: center;
      margin-bottom: 40px;
      .logo {
        margin-bottom: 24px;
        margin-right: auto;
        margin-left: auto;
      }
      .header-title {
        font-weight: 700;
        font-size: 17px;
        text-align: center;
        color: #000000;
        margin-bottom: 22px;
      }
      .subtitle {
        font-weight: 700;
        font-size: 16px;
        letter-spacing: 0.25px;
        color: #787878;

      }
    }
    .content {
      background: #f2f2f2;
      border-radius: 17px;
      padding: 32px;
      text-align: center;
      .icon-wrapper {
        margin-bottom: 25px;
        text-align: center;
        .icon {
          width: 46px !important;
          height: 33px !important;
          color: #103f5e;
        }
      }
      .content-title {
        font-size: 16px;
        color: #103f5e;
        font-family: "Lato";
        font-weight: 700;
        margin-bottom: 24px;
      }
      .content-info {
        font-weight: 400;
        font-size: 14px;
        letter-spacing: 0.25px;
        font-family: "Lato";
        color: #666666;
        margin-bottom: 32px;
      }
      .login-wrapper{
        height:44px;
        padding: 10px 32px;
        border-radius: 22px;
        text-align: center;
        background-color: #103F5E;
        .login-btn {
          font-size: 16px;
          font-family: "Lato";
          font-weight: 700;
          list-style: 19px;
          text-transform: uppercase;
          color: #FFFFFF;
      }
      }
      
    }
  }

  .mb-32{
    margin-bottom: 32px !important;
  }
}
</style>
